import Controller from '@ember/controller';
import { service } from '@ember/service';
import { action } from '@ember/object';

export default class EventWatchlistController extends Controller {
  @service eventData;
  @service watchlist;

  /**
   * Get the event data object
   */
  get eventDataObj() {
    return this.eventData.getEventData(this.model?.eventUuid);
  }

  /**
   * Get the event name for display
   */
  get eventName() {
    return this.eventDataObj?.event?.name || '';
  }

  /**
   * Page title
   */
  get pageTitle() {
    const eventName = this.eventName;
    return eventName ? `Watchlist - ${eventName}` : 'Watchlist';
  }

  /**
   * Get watched entries with full entry data
   * Returns array of objects with entry info and class name
   */
  get watchedEntries() {
    const eventUuid = this.model?.eventUuid;
    if (!eventUuid) return [];

    const eventDataObj = this.eventDataObj;
    if (!eventDataObj?.entries) return [];

    const watchedUuids = this.watchlist.getWatchedEntries(eventUuid);

    return watchedUuids
      .map(entryUuid => {
        const entry = eventDataObj.entries.get(entryUuid);
        if (!entry) return null;

        // Get class name for display
        const classObj = entry.classUuid ? eventDataObj.classes?.get(entry.classUuid) : null;

        return {
          uuid: entry.uuid,
          bib: entry.bib,
          name: [entry.firstName, entry.lastName].filter(Boolean).join(' '),
          club: entry.club,
          className: classObj?.name || ''
        };
      })
      .filter(Boolean)
      .sort((a, b) => {
        // Sort by bib number if available, otherwise by name
        if (a.bib && b.bib) {
          return String(a.bib).localeCompare(String(b.bib), undefined, { numeric: true });
        }
        return (a.name || '').localeCompare(b.name || '');
      });
  }

  /**
   * Check if watchlist has entries
   */
  get hasEntries() {
    return this.watchedEntries.length > 0;
  }

  /**
   * Remove a single entry from the watchlist
   */
  @action
  removeEntry(entryUuid) {
    this.watchlist.removeFromWatchlist(this.model.eventUuid, entryUuid);
  }

  /**
   * Clear all entries from the watchlist
   */
  @action
  clearAll() {
    this.watchlist.clearWatchlist(this.model.eventUuid);
  }
}
